<template>
  <section v-loading.fullscreen.lock="loading">
    <div v-if="getError" class="link-error">
      <div class="inner">
        <div class="icon">
          <img src="../../assets/img/icons/link-expired.png" alt="" />
        </div>
        <h1>{{ getError }}</h1>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      htmlTextData: "",
      loading: false,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters("respiratoryFileUpload", ["getSampleNameTestResultData"]),
    ...mapGetters("errors", ["getError"]),
    resultFileId() {
      return this.$route.params.result_file_id;
    },

    sampleNameId() {
      return this.$route.params.report_id;
    },
    testResultsId() {
      return this.$route.params.test_results_id;
    },
    showHTMLFiles() {
      if (
        this.getSampleNameTestResultData &&
        this.getSampleNameTestResultData.headers &&
        this.getSampleNameTestResultData.headers["content-type"] ==
          "text/html; charset=utf-8"
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        this.caseId = this.$route.params.case_id;
        await this.$store.dispatch(
          "respiratoryFileUpload/fetchCovidResultFileData",
          {
            result_file_id: this.resultFileId,
            sample_name_id: this.sampleNameId,
            test_results_id: this.testResultsId,
          }
        );

        if (
          this.getSampleNameTestResultData.data &&
          this.getSampleNameTestResultData.data.type == "application/pdf"
        ) {
          const arrayBuffer = this.getSampleNameTestResultData.data.data.data;
          const pdfBuffer = new Uint8Array(arrayBuffer);
          var blob = new Blob([pdfBuffer], { type: "application/pdf" });
          var blobURL = URL.createObjectURL(blob);
          let iframe =
            "<iframe src='" + blobURL + "' style='height:100%;width:100%'/>";
          document.write(iframe);
        } else {
          document.write(this.getSampleNameTestResultData.data);
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.link-error {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    position: relative;
    img {
      width: 150px;
      margin: 0 auto;
      display: table;
    }
  }
  h1 {
    margin-top: 0.5em;
    font-size: 1.4em;
    font-weight: 600;
    color: #3084ec;
    text-align: center;
  }
}
</style>
